import React from "react";
import NfsscProgramPageSection from "../../Sections/NfsscProgramPageSection/Content";
const NfsscProgramPage = () => {
  return <NfsscProgramPageSection />;
};

export default NfsscProgramPage;
